module.exports = __webpack_public_path__ + "img/email.1a9020c3.svg";